import {
    getTotal
} from '@/api/user'
import {
    Toast
} from 'vant';


export default {
    name: 'sign',
    data() {
        return {
            totalPoint: '0.0',
            todayPoint: '0.0'
        }
    },

    methods: {



    },

    mounted() {
        const that = this;
        getTotal().then(res => {
            that.totalPoint = res.data.total
            that.todayPoint = res.data.today
        }).catch(rej => {

        })


    }
}